import styled from 'styled-components'

import { fontWeight, color } from '../../styles'

import { fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const LaunchText = styled.p`
  font-weight: ${fontWeight.EXTRA};
  opacity: 0.7;
  font-size: ${fontSize.LARGE};
  line-height: 0.89;
  text-align: center;
  color: ${color.LEATHER};
`

export const CardHint = styled.p`
  font-weight: ${fontWeight.EXTRA};
  opacity: 0.25;
  font-size: ${fontSize.LARGE};
  line-height: 0.89;
  text-align: center;
  color: ${color.BLACK};
`

export const CardQuestion = styled.h1`
  font-weight: 900;
  font-size: ${fontSize.LARGE_XXXL};
  line-height: 1.25;
  text-align: center;
  margin: 0;
  color: ${color.CLAY_BROWN};
`

export const HintText = styled.p`
  font-size: ${fontSize.SMALL_EXTRA};
  font-weight: ${fontWeight.EXTRA};
  opacity: 0.25;
  color: ${color.BLACK};
`

export const ModalHeader = styled.h3`
  font-size: ${fontSize.LARGE_XXL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.33;
  text-align: center;
  color: ${color.GREYISH_BROWN};
  margin: 8.8rem 0 0.4rem 0;
`

export const ModalText = styled.p`
  font-size: ${fontSize.NORMAL};
  line-height: 1.5;
  text-align: center;
  color: ${color.WARM_GREY};
  margin: 0;
`

export const ModalHint = styled.p`
  font-size: ${fontSize.SMALL};
  line-height: 1.14;
  text-align: center;
  color: ${color.WARM_GREY};
  margin: 0;

  span {
    color: ${color.DUSTY_ORANGE};
  }
`

export const DownloadText = styled.h3`
  font-size: ${fontSize.LARGE_XL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.2;
  text-align: center;
  color: ${color.WARM_GREY};
  margin: 0 0 1.6rem 0;
`

export const LogInHeader = styled.h1`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 1.5;
  text-align: center;
  color: ${color.GREYISH_BROWN};
  margin: 3.2rem 0 1.6rem 0;

  ${media.desktop} {
    font-size: ${fontSize.LARGE_XXXL};
    line-height: 1;
    text-align: center;
    color: ${color.GREYISH_BROWN};
    margin: 3.2rem 0 0.8rem 0;
  }
`

export const InputLabel = styled.label`
  font-size: ${fontSize.SMALL};
  font-weight: ${fontWeight.BOLD};
  line-height: 1.14;
  color: ${color.WARM_GREY};
  margin-top: 1.6rem;
  margin-bottom: 0.8rem;
`

export const InputError = styled.p`
  font-size: ${fontSize.SMALL_EXTRA};
  font-weight: ${fontWeight.MEDIUM};
  line-height: 2;
  color: ${color.ORANGEY_RED};
  margin: 0;
`
